import React, { useState } from "react";
import { ReactComponent as ChevronDown } from "svgs/chevron-down.svg";
import clsx from "clsx/lite";
import { useSettings } from "hooks/useStore";

const DropdownMenu = ({ data, setShowOverlay, className, children, childrenClass, embedHeader }) => {
	const { toggleMenu, isSearchOpen, toggleSearch } = useSettings(["toggleMenu", "isSearchOpen", "toggleSearch"]);
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);

	const handleDropdownToggle = (isOpen) => {
		setIsDropdownOpen(isOpen);
		setShowOverlay(isOpen);
		toggleMenu(isOpen);
	};

	const handleOnClick = () => {
		isSearchOpen && toggleSearch();
		handleDropdownToggle(true);
	};

	const handleOnBlur = (event) => {
		if (!event.currentTarget.contains(event.relatedTarget) && !event.currentTarget?.classList.contains(childrenClass)) {
			handleDropdownToggle(false);
		}
	};

	return (
		<div
			className="group xl:justify-items-center cursor-pointer"
			aria-expanded={isDropdownOpen}
			onMouseEnter={() => !isSearchOpen && handleDropdownToggle(true)}
			onMouseLeave={() => !isSearchOpen && handleDropdownToggle(false)}
			onKeyDown={(e) => e.key === "Enter" && handleOnClick()}
			role="menu"
			aria-label={data.title}
			tabIndex="0"
		>
			<button
				onClick={handleOnClick}
				className={clsx("flex items-center cursor-pointer", !isSearchOpen && "group-hover:mx-[0.5px]", className)}
				role="menuitem"
			>
				{data.title}
				<ChevronDown
					className={clsx(
						!isSearchOpen && "group-hover:rotate-180",
						"transition-transform duration-300", embedHeader && "invert")} />
			</button>
			<div className="absolute hidden group-hover:flex w-32 h-1/2"></div>
			{!isSearchOpen &&
				<div onBlur={handleOnBlur}
					className={clsx(childrenClass, " transition-all duration-500 h-0 -mt-20 -z-10",
						!isSearchOpen && isDropdownOpen && "menu-dropdown-focus h-auto")}>
					{children}
				</div>}
		</div>
	);
};

export default DropdownMenu;